import PropTypes from "prop-types"
import React from "react"

import Chips from "src/components/Chips"

const FilterChips = ({
  table,
  statusOptions,
  scheduledOptions = [],
  onClearSearch,
  onClearAll,
}) => {
  const { filters } = table
  const chips = []

  if (filters.search) {
    chips.push({
      key: "search",
      text: `Search: ${filters.search}`,
      onClick: onClearSearch,
    })
  }

  if (filters.status?.length > 0) {
    filters.status.forEach((value) => {
      const label = statusOptions.find((o) => o.value === value)?.label || value
      chips.push({
        key: `status-${value}`,
        text: `Status: ${label}`,
        onClick: () =>
          table.setFilter(
            "status",
            filters.status.filter((s) => s !== value)
          ),
      })
    })
  }

  if (filters.scheduled?.length > 0) {
    filters.scheduled.forEach((value) => {
      const label =
        scheduledOptions.find((o) => o.value === value)?.label || value
      chips.push({
        key: `scheduled-${value}`,
        text: label,
        onClick: () =>
          table.setFilter(
            "scheduled",
            filters.scheduled.filter((s) => s !== value)
          ),
      })
    })
  }

  if (chips.length === 0) return null

  return (
    <Chips onReset={onClearAll}>
      {chips.map((chip) => (
        <Chips.Chip key={chip.key} text={chip.text} onClick={chip.onClick} />
      ))}
    </Chips>
  )
}

FilterChips.propTypes = {
  table: PropTypes.object.isRequired,
  statusOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  scheduledOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  onClearSearch: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
}

export default FilterChips
